export default __webpack_public_path__ + "static/media/vg-account.01db2f15.svg";